import Button from './button';

export default class Info extends Button {
  get buttonClass() {
    return 'ds-button--info';
  }
}
